import React from "react";
import "./palam_button.scss";

class PalamButton extends React.PureComponent {
  render() {
    let { children, extraClasses, ...rest } = this.props;
    let cssClass = "palam-button " + extraClasses;
    return (
      <button className={cssClass} {...rest}>
        {children}
      </button>
    );
  }
}

export default PalamButton;
